module.exports = __webpack_public_path__ + "a637632008e5a2c03d397899987289.svg";